<template>
  <div class="payment-history-base">
    <div class="no-items" v-if="noHistories">
      <img src="/static/img/icons/uranaitv_logo_lite.svg" />
      <span>購入した商品がありません</span>
    </div>
    <ul v-else >
      <li v-for="(item, index) in paymentHistories" >
        <span class="purchase-date">{{ item.date | dateFormat }}</span>
        <span class="main-info">
          <span class="title" :data-id="item.items_id">{{item.items_name}}</span>
          <span class="price">{{ item.payment | commaFormat }}<span class="unit-char">円</span></span>
        </span>
        <span class="point">{{item.point_status | pointGetStr}}：{{ item.point | commaFormat }}<span class="unit-char">pt</span></span>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment'
import FixedBackground from '@/utvStore/components/partials/FixedBackground'
import * as type from '@/utvStore/store/mutation-types'
import {mapState} from 'vuex'

export default {
  name: 'PaymentHistory',
  components: {
    FixedBackground
  },
  data(){
    return {
      noHistories: false
    }
  },
  props: {
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      paymentHistories: states => states.account.payment_history
    }),
  },
  watch: {
    paymentHistories: {
      handler(){
        const tgt = this.paymentHistories
        if(tgt.length > 0) {
          if('error' in tgt[0]){
            this.noHistories = true
          }
        }else {
          this.noHistories = true
        }
      },
      deep: true
    }
  },
  created() {
    if(Object.keys(this.userProfile).length > 0){
      this.$store.dispatch('GET_USER_PAYMENT_HISTORY', {uid: this.userProfile.id, accToken: this.accessToken})
    } else {
      this.noHistories = true
    }
  },
  filters: {
    pointGetStr(val) {
      switch (+val) {
        case 1:
        case 4:
          return '獲得'
        case 2:
        case 3:
        default:
          return '消費・失効'
      }
    },
    commaFormat(val) {
      return parseInt(val).toLocaleString()
    },
    dateFormat(val) {
      let dt = moment(parseInt(val)*1000).format('YYYY年M月D日')
      return dt
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';
.payment-history-base {
  width: 100%;
  & > ul {
    margin: 0;
    padding: 0;
    width: 100%;
    list-style: none;
    & > li {
      width: 100%;
      padding: 20px 20px 15px;
      border-bottom: 1px solid $col_temp_gray3;
      .purchase-date {
        display: block;
        width: 100%;
        text-align: left;
        font-weight: normal;
        font-size: 11px;
        line-height: 15px;
        color: $col_normal_font
      }
      .main-info {
        display: flex;
        justify-content: space-between;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        color: $col_base_black;
        .price {
          font-weight: bold;
          font-size: 16px;
          line-height: 24px;
          min-width: 70px;
          text-align: right;
          .unit-char {
            display: inline-block;
            font-size: 11px;
            transform-origin: bottom left;
            transform: scale(0.909) translate(1px, -1px);
          }
        }
      }
      .point {
        display: block;
        width: 100%;
        text-align: right;
        font-weight: bold;
        font-size: 11px;
        line-height: 15px;
        color: $col_temp_key1;
      }

    }
  }
}
.no-items {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 60px;
  font-size: 13px;
  line-height: 19px;
  color: $col_temp_gray5;
  img {
    display: block;
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/PaymentHistory.vue